module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Light-9166ce32434fe7e0535437fde7f55951.woff";